import { useMemo } from 'react';
import { useAuthedQueries } from './tanstack_query';
import gqlFetcher from '../gqlFetcher';
import { UI_GET_CURRICULA, UI_GET_SEMESTERS, UI_GET_GRADE_LIST, UI_GET_AGE_GROUPS } from '../../helpers/gqlQueries/ui/general';
const QUERIES = Object.fromEntries(Object.entries({
  curricula: UI_GET_CURRICULA,
  grades: UI_GET_GRADE_LIST,
  semesters: UI_GET_SEMESTERS,
  ageGroups: UI_GET_AGE_GROUPS
}).map(([key, query]) => [key, {
  queryFn: async () => (await gqlFetcher({
    document: query,
    variables: {}
  }))[key],
  queryKey: ['ui', key]
}]));
const rawCurriculaQueryFn = QUERIES.curricula.queryFn;
QUERIES.curricula.queryFn = async () => [...(await rawCurriculaQueryFn()), {
  id: 'my_assignments',
  name: 'My Assignments',
  subname: '',
  iconURL: 'https://f2b-cms.s3.amazonaws.com/prod/my_assignments_size_250_3b1b168708.png',
  color: '#A0A0A0',
  accessible: false
}, {
  id: '',
  name: 'Other',
  subname: '',
  iconURL: 'https://f2b-cms.s3.amazonaws.com/prod/unknown_curriculum_id_c15f00521e.svg',
  color: '#000000',
  accessible: false
}];
const useUiData = keys => {
  const queries = useMemo(() => Object.entries(QUERIES).filter(([k]) => keys.includes(k)), [keys]);
  return useAuthedQueries({
    queries: queries.map(([_, q]) => q),
    combine: queryResults => {
      const isPending = queryResults.some(res => res.isPending);
      const errors = queryResults.map(res => res.error).filter(Boolean);
      const isError = errors.length > 0;
      const data = Object.fromEntries(queries.map(([key], index) => [key, queryResults[index].data]));
      return {
        data,
        errors,
        isError,
        isPending
      };
    }
  });
};
export default useUiData;